export default function EmptyState({ title, description, action, testid }) {
    return (
        <div
            data-testid={testid || "empty-state"}
            className="border border-dashed border-border p-12 text-center bg-surface"
        >
            <div className="overline mb-3 text-muted-foreground">No data yet</div>
            <h3 className="font-display font-semibold text-lg mb-2">{title}</h3>
            {description && (
                <p className="text-sm text-muted-foreground max-w-md mx-auto leading-relaxed">
                    {description}
                </p>
            )}
            {action && <div className="mt-5 flex justify-center">{action}</div>}
        </div>
    );
}
